import { render, staticRenderFns } from "./editMenu.vue?vue&type=template&id=20f2e059&scoped=true&"
import script from "./editMenu.vue?vue&type=script&lang=js&"
export * from "./editMenu.vue?vue&type=script&lang=js&"
import style0 from "./editMenu.vue?vue&type=style&index=0&id=20f2e059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f2e059",
  null
  
)

export default component.exports